import IpSetIconImageWhite from "./../../icons/default/ipsetWhite.png";

import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const IpSetWhiteIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return <img style={style} className={className} src={IpSetIconImageWhite} />;
};
